import { Component, OnInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'travel-policy',
  templateUrl: './travel-policy.component.html',
  styleUrls: ['./travel-policy.component.css']
})
export class TravelPolicyComponent implements OnInit {

  currOrganization: any;
  loggedInUser: any;

  constructor(
    private activeModal: NgbActiveModal
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }
  }

  @Input() data: any;

  ngOnInit(){
    this.processBreadCrumbLinks();
  }

  private processBreadCrumbLinks() {
    console.log('history ', this.data);
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
